export const LockedIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 9.75V11.625M6 6.75V4.5C6 2.84314 7.34314 1.5 9 1.5C10.6568 1.5 12 2.84314 12 4.5V6.75M5.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V8.25C14.25 7.42157 13.5784 6.75 12.75 6.75H5.25C4.42157 6.75 3.75 7.42157 3.75 8.25V12.75C3.75 13.5784 4.42157 14.25 5.25 14.25Z"
      stroke="#ED0E1B"
      strokeWidth="1.40724"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LockdownIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3164 6.71698C12.3164 7.09003 12.014 7.39245 11.6409 7.39245H5.2321C4.85904 7.39245 4.55662 7.09003 4.55662 6.71698C4.55662 6.34392 4.85904 6.0415 5.2321 6.0415L11.6409 6.0415C12.014 6.0415 12.3164 6.34392 12.3164 6.71698Z"
      fill="#ED0E1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.80941 2.83363C6.55546 3.03843 6.34595 3.35583 6.25145 3.8828C6.18546 4.25071 5.89434 4.5568 5.52055 4.5568C5.14676 4.5568 4.83742 4.2524 4.88375 3.88149C4.99491 2.99155 5.34083 2.27905 5.95969 1.77997C6.69664 1.18565 7.69538 1 8.76055 1C11.1856 1 12.3173 2.77928 12.3173 4.1968V6.1105C12.6479 6.1773 13.0074 6.29762 13.3388 6.49645C13.9566 6.86718 14.4773 7.51991 14.4773 8.5168V9.93803C14.4773 10.3036 14.181 10.6 13.8154 10.6C13.4551 10.6 13.161 10.3119 13.1536 9.95178L13.1237 8.5168C13.1237 8.07369 12.9245 7.82642 12.6423 7.65715C12.3249 7.46667 11.9143 7.3936 11.6405 7.3936C11.2668 7.3936 10.9638 7.09059 10.9638 6.7168V4.1968C10.9638 3.45432 10.3675 2.3536 8.76055 2.3536C7.80972 2.3536 7.18846 2.52795 6.80941 2.83363Z"
      fill="#ED0E1B"
    />
    <path d="M3 5.27686L15 13.96L3 5.27686Z" fill="#ED0E1B" />
    <path
      d="M3 5.27686L15 13.96"
      stroke="#ED0E1B"
      strokeWidth="1.3536"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.3536 12.5131C4.3536 12.8685 4.48653 13.0254 4.61226 13.1159C4.77249 13.2313 4.9851 13.2763 5.1168 13.2763H11.7653C12.1391 13.2763 12.4421 13.5793 12.4421 13.9531C12.4421 14.3269 12.1391 14.6299 11.7653 14.6299H5.1168C4.7685 14.6299 4.26111 14.531 3.82134 14.2144C3.34707 13.8729 3 13.3097 3 12.5131V8.91313C3 8.53934 3.30301 8.23633 3.6768 8.23633C4.05059 8.23633 4.3536 8.53934 4.3536 8.91313V12.5131Z"
      fill="#ED0E1B"
    />
    <path
      d="M13.1386 13.5131C13.6129 13.1717 14.4922 14.857 14.4922 14.0604V9.91313C14.4922 9.53934 14.1892 9.23633 13.8154 9.23633C13.4416 9.23633 13.1386 9.53934 13.1386 9.91313V13.5131Z"
      fill="#ED0E1B"
    />
  </svg>
);

export const UnlockedIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 9.75V11.625M6.08979 3.76858C6.41632 2.46524 7.5954 1.5 9 1.5C10.6568 1.5 12 2.84314 12 4.5V6.75M5.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V8.25C14.25 7.42157 13.5784 6.75 12.75 6.75H5.25C4.42157 6.75 3.75 7.42157 3.75 8.25V12.75C3.75 13.5784 4.42157 14.25 5.25 14.25Z"
      stroke="#1BAC29"
      strokeWidth="1.40724"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CameraIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 16.666C10.8597 16.6694 11.7109 16.4807 12.5 16.1119L12.0504 12.7773C11.9849 12.2395 11.7408 11.7458 11.3636 11.3881C10.9864 11.0304 10.5018 10.8331 10 10.833C9.49822 10.8331 9.01358 11.0304 8.63637 11.3881C8.25916 11.7458 8.01509 12.2395 7.94964 12.7773L7.5 16.1313C8.29044 16.4935 9.14152 16.6755 10 16.666Z"
      stroke="#2055FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6673 10.25V7.5H3.33398V10.25C3.33398 11.9518 4.03636 13.5839 5.28661 14.7873C6.53685 15.9906 8.23254 16.6667 10.0007 16.6667C11.7688 16.6667 13.4645 15.9906 14.7147 14.7873C15.9649 13.5839 16.6673 11.9518 16.6673 10.25Z"
      stroke="#2055FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66602 3.33301H18.3327V6.45801C18.3327 6.73428 18.2351 6.99923 18.0615 7.19458C17.8878 7.38993 17.6523 7.49967 17.4068 7.49967H2.59194C2.34637 7.49967 2.11086 7.38993 1.93721 7.19458C1.76357 6.99923 1.66602 6.73428 1.66602 6.45801V3.33301Z"
      stroke="#2055FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CameraIconWhite = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 19.9996C13.0317 20.0037 14.053 19.7773 15 19.3346L14.4604 15.3332C14.3819 14.6878 14.089 14.0953 13.6364 13.6661C13.1837 13.2368 12.6021 13.0001 12 13C11.3979 13.0001 10.8163 13.2368 10.3636 13.6661C9.91099 14.0953 9.61811 14.6878 9.53957 15.3332L9 19.3579C9.94853 19.7926 10.9698 20.011 12 19.9996Z"
      stroke="#fff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 12.3V9L4 9V12.3C4 14.3422 4.84285 16.3007 6.34315 17.7447C7.84344 19.1888 9.87827 20 12 20C14.1217 20 16.1566 19.1888 17.6569 17.7447C19.1571 16.3007 20 14.3422 20 12.3Z"
      stroke="#fff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 4L22 4V7.75C22 8.08152 21.8829 8.39946 21.6746 8.63388C21.4662 8.8683 21.1836 9 20.8889 9L3.11111 9C2.81643 9 2.53381 8.8683 2.32544 8.63388C2.11706 8.39946 2 8.08152 2 7.75L2 4Z"
      stroke="#fff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
